<template>
  <div id="tree-head">
    <div class="left">
      <div class="cargo">
        <span class="text">
          {{node.cargo}}
        </span>
        <span class="about"><span class="link" @click="openSideView">Sobre</span></span>
      </div>
      <div class="tags">
        <div v-for="tag in tags">{{tag}}</div>
        <img :src="Question" alt="questão" @click="openModalTags">
      </div>
    </div>
    <div class="right">
      <div class="menu">
        <a class="vagasFTD" href="https://jobs.kenoby.com/souftd">#SouFTD</a>
        <!-- #conex&atilde;oFTD -->
        <a href="http://conexao.ftd.com.br"><img :src="logoConexFTD" class="logoFtd" width="160" alt="logo ConexãoFTD"></a>
        <div class="close" @click="closeView"><img :src="X" alt="fechar"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import EventSystem from '../utils/EventSystem';
  import Question from 'Assets/images/question.svg';
  import X from 'Assets/images/x.svg';
  import logoConexFTD from 'Assets/images/ftd_logo.svg';

  export default {
    props: {
    },
    data() {
      return {
        Question,
        X,
        logoConexFTD,
        node: { cargo: 'Carregando...' },
        tags: ['Nenhuma Tag'],
        cursos: [],
        vagas: [],
      };
    },
    created() {
      EventSystem.$on('tree-view-open', node => this.updateInfo(node));
      EventSystem.$on('tree-view-node-click', node => this.updateInfo(node));
    },
    computed: {
    },
    methods: {
      closeView() {
        EventSystem.$emit('tree-view-close');
      },
      openSideView() {
        EventSystem.$emit('tree-view-sidebar-open', this.node);
      },
      updateInfo(node) {
        this.node = node;
        this.tags = [node.front, node.direction, node.area];
        if (node.cursos && node.cursos.length > 0) {
          this.cursos = node.cursos.split('\n').reduce(this.reduceArray, []);
        } else {
          this.cursos = [];
        }
        if (node.vagas && node.vagas.length > 0) {
          this.vagas = node.vagas.split('\n').reduce(this.reduceArray, []);
        } else {
          this.vagas = [];
        }
      },
      reduceArray(acc, v) {
        const lastArr = acc.slice(-1)[0];
        if (lastArr && lastArr.length <= 1) {
          lastArr.push(`<a href="${v}">${v}</a>`);
        } else {
          acc.push([v]);
        }
        return acc;
      },
      openModalTags() {
        EventSystem.$emit('modal-open', {
          title: 'AJUDA - Interna',
          subtitle: 'Após selecionar um cargo, você poderá visualizar:',
          content: [
            ['Conexões naturais', 'Movimentações que representam o processo de evolução “natural”, trilhando a própria carreira, com a mesma natureza de atividade (mesma área/família de cargo).'],
            ['Conexões possíveis', 
              'As conexões possíveis são divididas em três classificações: <br> 1) Trilha Horizontal: movimentações sem alteração de nível de cargo e salários, porém com “famílias de cargo” diferentes, exigindo do colaborador certo grau de adaptação e desenvolvimento de novos conhecimentos, porém de mesmo nível de complexidade. <br> 2) Trilha Diagonal: movimentações (sempre para um nível superior) entre carreiras afins, porém famílias de cargo diferentes, exigindo do colaborador certo grau de adaptação e desenvolvimento de novos conhecimentos. <br> 3) Trilha para Liderança: possibilidade de promoções para cargos de liderança de acordo com as competências e habilidades exigidas para o cargo de destino, podendo ser natural, horizontal ou diagonal. '],
            ['Considerações importantes:', 
              'As trilhas desenhadas permitem possibilidades de movimentação de pessoas na estrutura da empresa. Nenhuma movimentação vertical ou horizontal é automática ou garantida. Elas devem obedecer os critérios vigentes na organização (orçamento e regras de movimentação). <br> As possibilidades mapeadas são de baixa e média dificuldade, outras possibilidades não mapeadas também são possíveis, porém, incorrem em maior dificuldade e dependerá da experiência e formação prévia do colaborador. <br> É importante que o colaborador observe a carreira como um todo,  analisando-a como um direcionador de desenvolvimento, para entender os requisitos e habilidades que demandam ações de longo prazo. '],
            ['Descritivo (Sobre)', 'A descrição, atividades e habilidades do cargo selecionado.'],
            ['#SouFTD', 'Vagas para movimentações internas disponíveis na FTD.']
          ],
        });
      },
      openModalVagas() {
        if (this.vagas.length <= 0) return;
        EventSystem.$emit('modal-open', {
          title: 'VAGAS',
          subtitle: '',
          content: this.vagas,
        });
      },
      openModalCursos() {
        if (this.cursos.length <= 0) return;
        EventSystem.$emit('modal-open', {
          title: 'FORMAR',
          subtitle: '',
          content: this.cursos,
        });
      }
    },
  };

</script>



// WEBPACK FOOTER //
// assets/js/source/vue-ui/tree-head.vue